// Configuration pour Azure Communication Services
export const AZURE_CHAT_CONFIG = {
  ACS_ENDPOINT:
    import.meta.env.VITE_CHAT_API_URL || 'https://cs-messagerie-dev.communication.azure.com',

  // Plateforme pour les notifications push
  PLATFORM: 'fcm', // ou 'apns' pour iOS
};
